import React from "react";

import ErrorPage from "../src/components/containers/errorPage";

const Page404 = () => {
  return <ErrorPage title="Page not found" subTitle="Please try your search again" code={404} />;
};

export default Page404;
